import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import fileDownload from 'js-file-download';
import {
  MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_BEGIN,
  MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_SUCCESS,
  MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_FAILURE,
  MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_DISMISS_ERROR,
} from './constants';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportOgmSubsData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/exportOrderGuideManageSubs`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_SUCCESS,
              data: res.data,
            });
            resolve(res);
          } else if (res.status === 504) {
            const errorMsg = "Export file sent to email due to large volume of data";
            dispatch({
              type: MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_FAILURE,
              data: { error: errorMsg },
            });
            resolve(res);
          }
        },
        (err) => {
          let errorMsg;
          if (err && err.response && err.response.status === 504) {
            errorMsg = "Export file sent to email due to large volume of data";
          } else if (err && err.response && err.response.status !== 200 && err.response.status !== 504) {
            errorMsg = "Something went wrong";
          } else {
            errorMsg = 'There is an error. Please refresh page or contact administrator.';
          }
          dispatch({
            type: MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportOgmSubsDataError() {
  return {
    type: MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_DISMISS_ERROR,
  };
}

export function useExportOgmSubsData() {
  const dispatch = useDispatch();

  const { exportOgmSubsDataPending, exportOgmSubsDataError } = useSelector(
    state => ({
      exportOgmSubsDataPending: state.manageSubs.exportOgmSubsDataPending,
      exportOgmSubsDataError: state.manageSubs.exportOgmSubsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportOgmSubsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportOgmSubsDataError());
  }, [dispatch]);

  return {
    exportOgmSubsData: boundAction,
    exportOgmSubsDataPending,
    exportOgmSubsDataError,
    dismissExportOgmSubsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportOgmSubsDataPending: true,
        exportOgmSubsDataError: null,
      };

    case MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_SUCCESS:
      // The request is success
      fileDownload(action.data, `Order Guide Subs Reports.xlsx`);
      return {
        ...state,
        exportOgmSubsDataPending: false,
        exportOgmSubsDataError: null,
      };

    case MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        exportOgmSubsDataPending: false,
        exportOgmSubsDataError: action.data.error,
      };

    case MANAGE_SUBS_EXPORT_OGM_SUBS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportOgmSubsDataError: null,
      };

    default:
      return state;
  }
}
